import { Linkedin, MessageCircle } from "lucide-react";

export default function ShareButtons({ url, title }) {
  const fullUrl = typeof window !== "undefined" ? `${window.location.origin}${url}` : url;
  const encoded = encodeURIComponent(fullUrl);
  const encodedText = encodeURIComponent(`Check out this opening: ${title} — `);

  const link = (href, label, Icon, testId) => (
    <a
      key={label}
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      data-testid={testId}
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition-colors hover:border-primary hover:text-primary"
    >
      <Icon className="h-4 w-4" />
    </a>
  );

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="mr-1 text-xs font-semibold uppercase tracking-wider text-slate-500">Refer:</span>
      {link(`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`, "LinkedIn", Linkedin, "share-linkedin")}
      {link(`https://api.whatsapp.com/send?text=${encodedText}${encoded}`, "WhatsApp", MessageCircle, "share-whatsapp")}
    </div>
  );
}
